import { Video } from "./types";
import { mixedEnum, object } from "./helpers";
import {
  Enum_MonitorDisplay_Primary,
  Enum_MonitorDisplay_Secondary_Willie
} from "generated/graphql";
import { LocalKeys } from "utilities/i18n";

export const video = object<Video>({
  monitor: object({
    ONE: object({
      display: mixedEnum(
        Enum_MonitorDisplay_Primary,
        "CONFIGURE_MONITOR_1" as LocalKeys
      ).default(Enum_MonitorDisplay_Primary.Auto)
    }),
    TWO: object({
      display: mixedEnum(
        Enum_MonitorDisplay_Secondary_Willie,
        "CONFIGURE_MONITOR_2" as LocalKeys
      ).default(Enum_MonitorDisplay_Secondary_Willie.Auto)
    })
  })
});
